<template lang='pug'>
    div
        TransformerPartsSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'de'")

            div.title-container
                h1.product-title Anschweißflansch Set
                h2.product-subtitle Anschweißflansch für UHF-Fenstersensoren

            div.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/Welding_Ring_Set.webp')
                            img( src='@/assets/photos/product_shots/Welding_Ring_Set.png', width="100%", alt='BSS Welding Ring Set', title='BSS Welding Ring Set')

                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Zur Montage von unserem 
                                    a.backlink(href='/de/products/transformerparts/dielectric-window-set') dielektrischen Fenster
                                    |  und UHF-Fenstersensoren in der Kesselwand von ölgefüllten Transformatoren 
                                li Aus rostfreiem Edelstahl gefertigt 
                                li Konstruiert gemäß Cigré TB 662 
                                li Geeignet für unseren 
                                    a.backlink(href='/de/products/uhfsensors/uhf-ps1') UHF-PS1 Teilentladungssensor
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, englisch)', link="/pdf/Datasheet Welding Ring Set.pdf")
                            Maillink(to='support@bss-hs.de', sub='CAL-UHF', text='Kontaktieren Sie uns', size=30, strokeWidth=2)
                            //Sitelink(to="/de/products/pdm-600", text='UHF-TE-Monitoring-System PDM-600')
                            Sitelink(to="/de/products/uhfsensors/uhf-ps1", text='UHF-Fenstersensor UHF-PS1')
                            Sitelink(to="/de/products/transformerparts/dielectric-window-set", text='Dielektrisches Fenster Set')

            section
            p
                | Der Anschweißflansch ist ein hochwertiger Montageflansch aus rostfreiem Edelstahl, entwickelt für die Installation von UHF-Fenstersensoren wie dem 
                a.backlink(href='/de/products/uhfsensors/uhf-ps1') UHF-PS1
                |  in der Kesselwand von ölgefüllten Transformatoren. Der Anschweißflansch wird während der Kesselfertigung in die Kesselwand geschweißt.
            p
                | Der Anschweißflansch ist mit unserem 
                a.backlink(href='/de/products/transformerparts/dielectric-window-set') dielektrischen Fenster
                |  auszustatten, einer Ölbarriere aus dem Hochleistungskunststoff PEEK. Diese Lösung garantiert die Öl- und Vakuumdichtigkeit des Transformators und ermöglicht die nachträgliche Installation von UHF-Fenstersensoren. Dadurch bietet sich maximale Flexibilität bei der Nachrüstung von TE-Monitoringsystemen wie dem 
                a.backlink(href='/de/products/pdm-600') PDM-600.
            p
                | Der Anschweißflansch wurde gemäß Cigré TB 662 (Guidelines for partial discharge detection using conventional and unconventional methods) konstruiert. Darüber hinaus empfiehlt Cigré TB 343 (Recommendations for condition monitoring and condition assessment facilities for transformers) neue Transformatoren mit DN50-Ventilen oder dielektrischen Fenstern auszustatten, um die nahtlose Integration von UHF-Sensoren zu einem späteren Zeitpunkt zu ermöglichen. 
            p
                | Im Lieferumfang enthalten sind der Anschweißflansch, ein Blinddeckel aus Edelstahl, ein FPM-Dichtungsring sowie Edelstahlschrauben für die Befestigung des Blinddeckels oder des Fenstersensors. Das Anschweißflansch Set ist in den Ausführungen V2A- und V4A-Edelstahl erhältlich. 

        div.fullwidth(v-if="$route.params.lang == 'en'")

            div.title-container
                h1.product-title Welding Ring Set
                h2.product-subtitle Mounting Flange for Window-Type PD Sensors

            div.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/Welding_Ring_Set.webp')
                            img( src='@/assets/photos/product_shots/Welding_Ring_Set.png', width="100%", alt='BSS Welding Ring Set', title='BSS Welding Ring Set')
                        
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Mounting flange for dielectric window and window-type PD sensors
                                li For mounting in tank wall of oil-filled transformers
                                li Made from solid stainless steel
                                li Design according to Cigré TB 662
                                li Designed to be equipped with our <a class="backlink" href='/en/products/transformerparts/dielectric-window-set'>Dielectric Window Set</a>
                                li Suitable for our <a class="backlink" href='/en/products/uhfsensors/uhf-ps1'>UHF-PS1 PD Sensor</a>
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet Welding Ring Set.pdf")
                            Maillink(to='support@bss-hs.de', sub='CAL-UHF', text='Contact Us', size=30, strokeWidth=2)
                            //Sitelink(to="/en/products/pdm-600", text='UHF PD Monitoring System PDM-600')
                            Sitelink(to="/en/products/uhfsensors/uhf-ps1", text='Window-Type PD Sensor UHF-PS1')
                            Sitelink(to="/en/products/transformerparts/dielectric-window-set", text='Dielectric Window Set')
                        
            section
            section
                p 
                    | The Welding Ring is a high-quality stainless steel mounting flange for window-type UHF partial discharge (pd) sensors such as the 
                    a.backlink(href='/en/products/uhfsensors/uhf-ps1') UHF-PS1
                    | . It is engineered to be welded into the tank wall of new power transformers during manufacturing of the tank. To ensure oil-tight sealing, the Welding Ring must be equipped with our 
                    a.backlink(href='/en/products/transformerparts/dielectric-window-set') Dielectric Window
                    | , a high-performance oil barrier made from PEEK. This solution guarantees the vacuum capable integrity of the transformer and allows for the later installation of window-type UHF sensors in power transformers, offering flexibility in future installments of partial discharge monitoring systems such as the 
                    a.backlink(href='/en/products/pdm-600') PDM-600
                    | .
                p The Welding Ring is designed according to Cigré TB 662 (Guidelines for partial discharge detection using conventional and unconventional methods). Cigré TB 343 (Recommendations for condition monitoring and condition assessment facilities for transformers) recommends installing DN50 valves or dielectric windows in new transformers to facilitate seamless integration of UHF sensors at a later stage.
                p The Welding Ring Set consists of the Welding Ring, a stainless steel blind cover plate, stainless steel screws, and a FPM sealing ring. The Welding Ring Set is available in V2A and V4A stainless steel versions. 


</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | Anschweißflansch Set",
            description:
                "Anschweißflansch für UHF-Fenstersensoren",
        },
        en: {
            title: "BSS | Welding Ring Set",
            description:
                "Welding Ring Set for Window-Type UHF PD Sensors",
        },
    },
};
</script>

<style lang='sass' scoped>
    .backlink
        color: $color2
        text-decoration: none
        font-weight: bold
</style>